<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OQFVKa/tc-custom/9780061753978.jpg?1730610903263" alt="This image is the cover for the book Thomas Jefferson, Eminent Lives"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Thomas Jefferson, Eminent Lives
      </h1>
      <p class="bookDescription body article font2">
        <p><b>"A balanced, readable portrait. A refreshing perspective.” —<i>New York Times Book Review</i></b></p><p><b>With intelligence, insight, eloquence, and wit, bestselling author Christopher Hitchens gives us an artful portrait of a complex, formative figure in American history and his turbulent era</b>.</p><p>In this unique biography of Thomas Jefferson, leading journalist and social critic Christopher Hitchens offers a startlingly new and provocative interpretation of our Founding Father—a man conflicted by power who wrote the Declaration of Independence and acted as ambassador to France yet yearned for a quieter career in the Virginia legislature. A masterly writer, Jefferson was an awkward public speaker. A professed proponent of emancipation, he elided the issue of slavery from the Declaration of Independence and continued to own human property. A reluctant candidate, he left an indelible presidential legacy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Hitchens
      </h2>
      
      <p class="authorDescription body article"><P>Christopher Hitchens&#160;was the author of numerous books, including the controversial international bestseller <I>God Is Not Great: How Religion Poisons Everything</I>. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e9deca62